import { render } from "./FollowUpField.vue?vue&type=template&id=a425bd4a&lang=pug"
import script from "./FollowUpField.vue?vue&type=script&lang=js"
export * from "./FollowUpField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__